import React from 'react';
import './SaveStatusFeedback.css';

export type SaveStatus = 'idle' | 'saving' | 'success' | 'error' | 'retrying' | 'dirty';

interface SaveStatusFeedbackProps {
  /** 現在の保存状態 */
  status: SaveStatus;
  /** エラーメッセージ（任意） */
  errorMessage?: string;
}

const SaveStatusFeedback: React.FC<SaveStatusFeedbackProps> = ({
  status,
  errorMessage
}) => {
  // ステータスに応じたメッセージとスタイルクラスを決定
  const getStatusInfo = () => {
    switch (status) {
      case 'success':
        return {
          message: 'データを更新しました',
          className: 'save-status-feedback--success'
        };
      case 'error':
        return {
          message: errorMessage || '保存に失敗しました',
          className: 'save-status-feedback--error'
        };
      case 'retrying':
        return {
          message: '保存を再試行中です',
          className: 'save-status-feedback--retrying'
        };
      case 'dirty':
        return {
          message: '未保存あり',
          className: 'save-status-feedback--dirty'
        };
      case 'saving':
        return {
          message: '保存中...',
          className: 'save-status-feedback--saving'
        };
      case 'idle':
      default:
        return null;
    }
  };

  const statusInfo = getStatusInfo();

  // アイドル状態では何も表示しない
  if (!statusInfo) {
    return null;
  }

  return (
    <div className={`save-status-feedback ${statusInfo.className}`}>
      <span className="save-status-feedback__text text-single-small">
        {statusInfo.message}
      </span>
    </div>
  );
};

export default SaveStatusFeedback;
